import React, { Component } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import QuizMiddleware from '../../store/middleware/quizMiddleware';
import { connect } from 'react-redux';

let isPaused = false
let myVar ;

var user;

class QuizStart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            questionNumber: props.location.state.attemptedQuestions,
            singleAnswer: null,
            choices: null,
            answerType: "",
            multipleAnswers: [],
            loaderState: false,
            time: {},
            seconds: props.location.state.time * 60,
            courseTime: true,
            selected : [],
            popup : false,
            answerTime:0,
            quizTime : 0,
            number : 0
        }
        this.timer = 0;
        this.countDown = this.countDown.bind(this);
        
        window.onbeforeunload = function () {
            sessionStorage.removeItem('proctoringKey')
            if(window.location.pathname == '/quiz/start'){
                sessionStorage.removeItem('token')
            }
            return false;
        };
    }

    componentWillReceiveProps(nextprops) {
        // console.log(nextprops.answer)
        var userProps = JSON.parse(sessionStorage.getItem('sessionStorageUser'))
        if(!userProps){
            this.props.history.push('/');
        }
        if (this.state.number > this.props.location.state.questionDetails.length - 1) {
            this.props.history.replace('/showResult', { answerSheetDetails: this.props.location.state.answerSheetDetails, userDetails: user, quizDetails: this.props.location.state.quizDetails, classDetails :this.props.location.state.classDetails, isTimeUp : false, timeConsumed : this.state.quizTime  })
        }
    }

    componentDidMount() {
        let timeLeftVar = this.secondsToTime(this.state.seconds);
        this.setState({
            time: timeLeftVar
        }, () => {
            if (this.state.courseTime) {
                if (this.state.seconds > 0) {
                    this.timer = setInterval(this.countDown, 1000);
                }
            }
        })

        if(this.props.location.state.answerSheetDetails && this.props.location.state.answerSheetDetails.timeConsumed) {
            this.setState({
                quizTime : this.props.location.state.answerSheetDetails.timeConsumed
            })
        }
    }

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    countDown() {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        if(!isPaused) {
            this.setState({
                time: this.secondsToTime(seconds),
                seconds: seconds,
                answerTime:this.state.answerTime+1,
                quizTime : this.state.quizTime+1
            });
        }
        if(this.props.networkLost){
            isPaused = true
        }
        else if(this.props.networkConnected){
            isPaused = false
        }

        // Check if we're at zero.
        if (seconds == 0) {
            clearInterval(this.timer);
            this.setState({
                popup : true
            })
            myVar = setTimeout(this.handleClose,5000)
        }
    }
    
    handleClose = () => {
        this.setState({ popup: false });
        clearTimeout(myVar)
        this.props.history.replace('/showResult', { answerSheetDetails: this.props.location.state.answerSheetDetails, userDetails: user, quizDetails: this.props.location.state.quizDetails, classDetails :this.props.location.state.classDetails, isTimeUp : true, timeConsumed : this.state.quizTime })
      };

    submitAnswer() {
        this.props.submitAnswer({
            answer: this.state.singleAnswer,
            courseId: this.props.location.state.quizDetails.quiz.course,
            quizId: this.props.location.state.quizDetails.quiz._id,
            answerSheetId: this.props.location.state.answerSheetDetails._id,
            questionId: this.props.location.state.questionDetails[this.state.number]._id,
            answerType: this.state.answerType,
            answerChoices: this.state.choices,
            isSingleSelect: this.props.location.state.questionDetails[this.state.number].isSingleSelect,
            timeConsumed : this.state.answerTime,
            quizTime : this.state.quizTime
        })

        this.setState({
            questionNumber: ++this.state.questionNumber,
            number : ++this.state.number,
            singleAnswer: null,
            choices : null,
            multipleAnswers: [],
            selected : [],
            answerTime:0
        })
        if (this.state.number > this.props.location.state.questionDetails.length - 1) {
            clearInterval(this.timer);
            this.setState({
                loaderState: true
            })
        }
    }

    selectAnswers = (selection, index) => {
        if (this.props.location.state.questionDetails[this.state.number].choices) {
            let arry = []
            let questionLength = this.props.location.state.questionDetails[this.state.number].choices

            for (var i = 0; i < questionLength.length; i++) {
                const object2 = Object.assign({ selectedAnswer: false, questionOptionId: questionLength[i]._id }, questionLength[i]);
                arry.push(object2)
            }
            if (this.props.location.state.questionDetails[this.state.number].isSingleSelect === true) {
                let singleSelect = this.props.location.state.questionDetails[this.state.number].choices[index]
                const object2 = Object.assign({ selectedAnswer: true, questionOptionId: questionLength[index]._id }, singleSelect);
                arry.splice(index, 1, object2);
            }

            if (!this.props.location.state.questionDetails[this.state.number].isSingleSelect) {
                arry=[]
                let multipleSelect = this.state.multipleAnswers
                if (multipleSelect.includes(index)) {
                    multipleSelect.splice(multipleSelect.indexOf(index), 1)
                }
                else {
                    multipleSelect.push(index)
                }

                multipleSelect= multipleSelect.sort();
                this.setState({ multipleAnswers: multipleSelect })

                questionLength.forEach((obj,index)=>{
                    if(multipleSelect.indexOf(index)!=-1){
                        arry.push({
                            ...obj,
                            selectedAnswer:true,
                            questionOptionId:obj._id
                        })
                    }
                    else{
                        arry.push({...obj,selectedAnswer:false,questionOptionId:obj._id})
                    }
                })
            }

            this.setState({
                choices: arry
            })
        }

        if (this.props.location.state.questionDetails[this.state.number]._type === "TrueFalseQuestion") {
            this.setState({
                answerType: "TrueFalseAnswer"
            })
        }
        else if (this.props.location.state.questionDetails[this.state.number]._type === "MCQ") {
            this.setState({
                answerType: "MCQAnswer"
            })
        }
        this.setState({ singleAnswer: selection });
    };

    handleChange = name => event => {
        let oldArray = this.state.selected;
        if (oldArray.indexOf(name) != -1) {
          oldArray.splice(oldArray.indexOf(name), 1);
        } else {
          oldArray.push(name);
        }
        this.setState({ selected: oldArray });
      };

    render() {
        user = JSON.parse(sessionStorage.getItem('sessionStorageUser'))
        return (
            <div style={{ top: "15%", justifyContent: "center", alignItems: "center", display: "flex", width: "100%", flexDirection: "column", position: "absolute" }}>
                <Paper style={{ top: "70px", backgroundColor: "white", width: "100%", display: "flex", alignItems: "flex-end", justifyContent: "center" }} elevation={0} >
                    <Paper style={{ width: "85%", padding: "1%", zIndex: "1", bottom: 0, height : "46px", display : "flex", alignItems : "center" }}>
                        <Typography style={{ float: "left", fontWeight: "bold" }}>Quiz : {this.props.location.state.quizDetails.quiz.title}</Typography>
                        <Typography id="demo" style={{ fontWeight: "bold", color : this.state.time.h == 0 && this.state.time.m <= 4 ? 'red' : 'black', display : "flex", flex : '1', justifyContent : "flex-end" }}>{this.state.time.h} : {this.state.time.m}  : {this.state.time.s}</Typography>
                    </Paper>
                </Paper>
                {this.state.loaderState ? <h2 style={{ marginTop: "5%" }}> Wait for the result.... </h2> :
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                        <Typography className='question-number'>Question : {this.state.questionNumber + 1} of {this.props.location.state.totalQuestions} </Typography>

                        <Paper style={{ width: "80vw", padding: "20px", backgroundColor: "#f6f6f6", whiteSpace: "pre-line" }}>
                            {this.props.location.state.questionDetails[this.state.number].containsHTML ?
                                <Typography dangerouslySetInnerHTML={{__html:this.props.location.state.questionDetails[this.state.number].html}} />
                                :
                                <Typography>{this.props.location.state.questionDetails[this.state.number].html}</Typography>
                            }
                        </Paper>

                        {/* For True False Question */}
                        {this.props.location.state.questionDetails[this.state.number]._type === "TrueFalseQuestion" ?
                            <div style={{ width: "82vw" }}>
                                <Paper style={{ marginTop: "20px" }}>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <Typography style={{ backgroundColor: "#f6f6f6", minWidth: "7%", display: "flex", justifyContent: "center" }}>
                                            <FormControlLabel value="true" control={<Radio color="default" checked={this.state.singleAnswer == true} style={{ width: "100%" }} onClick={() => this.selectAnswers(true)} icon={<RadioButtonUncheckedIcon style={{ fontSize: "15" }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: "15" }} />} />} label="1." style={{ marginLeft: "2%" }} />
                                        </Typography>
                                        <Typography style={{ marginLeft: "1%" }}>True</Typography>
                                    </div>
                                </Paper>

                                <Paper style={{ marginTop: "20px" }}>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <Typography style={{ backgroundColor: "#f6f6f6", minWidth: "7%", display: "flex", justifyContent: "center" }}>
                                            <FormControlLabel value="false" control={<Radio color="default" checked={this.state.singleAnswer == false} style={{ width: "100%" }} onClick={() => this.selectAnswers(false)} icon={<RadioButtonUncheckedIcon style={{ fontSize: "15" }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: "15" }} />} />} label="2." style={{ marginLeft: "2%" }} />
                                        </Typography>
                                        <Typography style={{ marginLeft: "1%" }}>False</Typography>
                                    </div>
                                </Paper>
                            </div> : ""
                        }


                        {/* For MCQ Question with single select */}
                        {this.props.location.state.questionDetails[this.state.number]._type === "MCQ" && this.props.location.state.questionDetails[this.state.number].isSingleSelect === true ?
                            this.props.location.state.questionDetails[this.state.number].choices && this.props.location.state.questionDetails[this.state.number].choices.length && this.props.location.state.questionDetails[this.state.number].choices.map((data, index) => {
                                return <Paper style={{ marginTop: "20px" }} key={index}>
                                    <div style={{ width: "82vw", display: "flex", alignItems: "center", background : "linear-gradient(90deg, #f6f6f6 7%, #ffffff 7%" }}>
                                        <Typography style={{ backgroundColor: "#f6f6f6", minWidth: "7%", display: "flex", justifyContent: "center" }}>
                                            <FormControlLabel value={data.html} control={<Radio color="default" checked={this.state.singleAnswer === data._id} style={{ width: "100%" }} onClick={() => this.selectAnswers(data._id, index)} icon={<RadioButtonUncheckedIcon style={{ fontSize: "15" }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: "15" }} />} />} label={index + 1 + "."} style={{ marginLeft: "2%" }} />
                                        </Typography>
                                        <Typography style={{ marginLeft: "1%", whiteSpace: "pre-line" }}>{data.html}</Typography>
                                    </div>
                                </Paper>
                            }) : ""
                        }

                        {/* For MCQ Question with Multiple select */}
                        {this.props.location.state.questionDetails[this.state.number]._type === "MCQ" && !this.props.location.state.questionDetails[this.state.number].isSingleSelect ?
                            this.props.location.state.questionDetails[this.state.number].choices && this.props.location.state.questionDetails[this.state.number].choices.length && this.props.location.state.questionDetails[this.state.number].choices.map((data, index) => {
                                return <FormGroup style={{ width: "82vw" }} key={index}>
                                    <Paper style={{ marginTop: "20px" }}>
                                        <div style={{ width: "82vw", display: "flex", alignItems: "center", background : "linear-gradient(90deg, #f6f6f6 7%, #ffffff 7%" }}>
                                            <Typography style={{ backgroundColor: "#f6f6f6", minWidth: "7%", display: "flex", justifyContent: "center" }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            onClick={() => this.selectAnswers(data.html, index)}
                                                            value={data.html}
                                                            color="default"
                                                            icon={<CheckBoxOutlineBlankIcon style={{ fontSize: "15" }} />}
                                                            checkedIcon={<CheckBoxIcon style={{ fontSize: "15" }} />}
                                                            style={{ width: "100%" }}
                                                            checked={this.state.multipleAnswers.indexOf(index) != -1}
                                                            onChange={this.handleChange(data.html)}
                                                        />
                                                    }
                                                    label={index + 1 + "."}
                                                    style={{ marginLeft: "2%" }}
                                                />
                                            </Typography>
                                            <Typography style={{ marginLeft: "1%", whiteSpace: "pre-line" }}>{data.html}</Typography>
                                        </div>
                                    </Paper>
                                </FormGroup>
                            }) : ""
                        }
                        <div style={{ width: "82vw", margin: "20px" }}>
                            <div>{!this.props.location.state.questionDetails[this.state.number].isSingleSelect && this.props.location.state.questionDetails[this.state.number]._type === "MCQ" ?
                                <Button disabled={!this.state.selected.length ? true : null } color={!this.state.selected.length ? null : "primary"} variant="contained" onClick={() => this.submitAnswer()} style={{ float: "right" }}>Next</Button> :
                                <Button disabled={this.state.singleAnswer === null ? true : null } color={this.state.singleAnswer === null ? null : "primary"} variant="contained" onClick={() => this.submitAnswer()} style={{ float: "right" }}>Next</Button>}
                            </div> 
                        </div>
                    </div>}
                    {this.state.popup ?
                        <Dialog
                            open={true}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            fullWidth
                        >
                            <DialogTitle id="alert-dialog-title">{"Time Up!"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Your time is up.
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleClose} color="primary" autoFocus>
                                    Ok
                                </Button>
                            </DialogActions>
                        </Dialog>
                        : ""
                }
            </div>

        )
    }
}

function mapStateToProps(state) {
    // console.log(state)
    return {
        answer: state.quizReducer.submitAnswer,
        networkLost : state.errorReducer.buttonDisable,
        networkConnected : state.errorReducer.buttonEnable,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        submitAnswer: (data) => dispatch(QuizMiddleware.submitAnswerMiddleware(data))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(QuizStart);


// WEBPACK FOOTER //
// ./src/container/QuizStart/quizstart.js